const DELIVERY_COMPARE_FIELDS = ['name', 'phone', 'location', 'address']

export function normalizeDeliveryValue (value) {
  if (value === null || value === undefined) return ''
  return String(value).trim().toLowerCase()
}

export function isDeliveryDocument (source) {
  if (!source) return false
  if (source.deliveries || source.cart || source.payManual) return false
  return !!(source.delivery || source.nameRecipient !== undefined)
}

export function getDeliveryComparableValues (source) {
  if (!source) {
    return {
      name: '',
      phone: '',
      location: '',
      department: '',
      address: ''
    }
  }

  const isDeliveryDoc = isDeliveryDocument(source)

  if (isDeliveryDoc) {
    return {
      name: source.nameRecipient || '',
      phone: (source.phonesRecipient && source.phonesRecipient[0]) || '',
      location: source.locationRecipient || '',
      department: source.departmentRecipient || '',
      address: source.addressRecipient || ''
    }
  }

  return {
    name: source.name || '',
    phone: (source.phones && source.phones[0]) || '',
    location: source.location || '',
    department: source.department || '',
    address: source.address || ''
  }
}

export function deliveryFieldDiffers (entry, reference, field) {
  if (!entry || !reference) return false

  const current = getDeliveryComparableValues(entry)
  const ref = getDeliveryComparableValues(reference)

  if (field === 'name') {
    return normalizeDeliveryValue(current.name) !== normalizeDeliveryValue(ref.name)
  }

  if (field === 'phone') {
    return normalizeDeliveryValue(current.phone) !== normalizeDeliveryValue(ref.phone)
  }

  if (field === 'location') {
    return normalizeDeliveryValue(current.location) !== normalizeDeliveryValue(ref.location) ||
      normalizeDeliveryValue(current.department) !== normalizeDeliveryValue(ref.department)
  }

  if (field === 'address') {
    return normalizeDeliveryValue(current.address) !== normalizeDeliveryValue(ref.address)
  }

  return false
}

export function getDeliveryReferenceForEntry (record, displayIndex) {
  const deliveries = (record && record.deliveries) || []
  if (!deliveries.length) return record

  const originalIndex = deliveries.length - 1 - displayIndex

  if (originalIndex >= deliveries.length - 1) {
    return record
  }

  return deliveries[originalIndex + 1]
}

export function deliveryEntryDiffersFromReference (entry, reference) {
  return DELIVERY_COMPARE_FIELDS.some(field => deliveryFieldDiffers(entry, reference, field))
}

export function recordHasDeliveries (record) {
  return !!(record && record.deliveries && record.deliveries.length)
}

export function latestDeliveryDiffersFromRecord (record) {
  const deliveries = (record && record.deliveries) || []
  if (!deliveries.length) return false

  const latest = deliveries[deliveries.length - 1]
  return deliveryEntryDiffersFromReference(latest, record)
}

export function canDeclineDeliveryDoc (deliveryDoc) {
  if (!deliveryDoc || deliveryDoc.status === 'declined') return false
  if (deliveryDoc.status !== 'created' && deliveryDoc.status !== 'inprogress') return false
  if (deliveryDoc.tracking && !deliveryDoc.trackingCancelled) return false
  return true
}

export function canCancelTrackingDoc (deliveryDoc) {
  return !!(deliveryDoc && deliveryDoc.tracking && !deliveryDoc.trackingCancelled)
}

export function getLatestDelivery (record) {
  const deliveries = (record && record.deliveries) || []
  return deliveries.length ? deliveries[deliveries.length - 1] : null
}

export function canDownloadDeliveryLabel (record) {
  const deliveryDoc = getLatestDelivery(record)
  if (!deliveryDoc || deliveryDoc.status === 'declined') return false
  if (deliveryDoc.trackingCancelled) return false
  return !!(deliveryDoc.tracking && (deliveryDoc.idRemission || deliveryDoc.idWelivery))
}

export function canCreateNewDeliveryForRecord (record) {
  const deliveryDoc = record && record.deliveries && record.deliveries.at(-1)
  return !!(deliveryDoc && deliveryDoc.status === 'declined')
}



// WEBPACK FOOTER //
// ./src/helpers/deliveryMass.js